import { faToggleOff, faToggleOn } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext } from "react";
import Label from "react-bootstrap/Badge";
import Icon from "react-cismap/commons/Icon";
import { TopicMapContext } from "react-cismap/contexts/TopicMapContextProvider";
import { UIContext, UIDispatchContext } from "react-cismap/contexts/UIContextProvider";
import ResponsiveInfoBox from "react-cismap/topicmaps/ResponsiveInfoBox";

import { setSimulationStateInUrl } from "../../helper";
import Legend from "../Legend";
import SimulationColumn from "./SimulationColumn";
import MapColumn from "./MapColumn";
import AdditionalToggleColumn from "./AdditionalToggleColumn";

/* eslint-disable jsx-a11y/anchor-is-valid */

// Since this component is simple and static, there's no parent container for it.
const ControlInfoBox = ({
  pixelwidth,
  selectedSimulation,
  legendObject,
  featureInfoModeActivated = false,
  featureInfoModeBlocked = false,
  setFeatureInfoModeActivation,
  featureInfoValue,
  setSelectedSimulation,
  simulations,
  animationEnabled,
  setAnimationEnabled,
  backgrounds,
  selectedBackgroundIndex,
  setBackgroundIndex,
  secondaryInfoBoxElements,
  additionalLayers,
  animationSwitch = false,
  setAdditionalLayers,
  toggleSwitch = false,
  toggleTitle = "ToogleTitle",
  simulationTitle = "Simulation",
  toggleEnabled = false,
  setToggleEnabled = () => {},
  toggleClickable = true,

  toggleEnabledTooltip,
  toggleDisabledTooltip,
  toggleEnabledText,
  toggleDisabledText,

  order = ["S", "M", "T"],
}) => {
  const simObject = simulations[selectedSimulation];

  const legend = <Legend legendObjects={legendObject} />;

  //contextStuff
  const { setAppMenuVisible, setAppMenuActiveMenuSection } = useContext(UIDispatchContext);
  const { history } = useContext(TopicMapContext);

  const showModalMenu = (section) => {
    setAppMenuVisible(true);
    setAppMenuActiveMenuSection(section);
  };

  let mapCursor;
  if (featureInfoModeActivated) {
    mapCursor = "crosshair";
  } else {
    mapCursor = "grabbing";
  }

  const legendTable = (
    <table onClick={(e) => e.stopPropagation()} key="legendTable" style={{ width: "100%" }}>
      <tbody>
        <tr>
          <td
            style={{
              opacity: "0.9",
              paddingLeft: "0px",
              paddingTop: "0px",
              paddingBottom: "0px",
            }}
          >
            {legend}
          </td>
        </tr>
      </tbody>
    </table>
  );

  let simulationLabels = [];
  simulations.forEach((item, index) => {
    let bsStyle, label;
    if (!item.additionalLayerConfig) {
      if (selectedSimulation === index) {
        bsStyle = "primary";
      } else {
        bsStyle = "secondary";
      }

      label = (
        <a
          style={{ textDecoration: "none" }}
          onClick={() => {
            setSimulationStateInUrl(index, history);
            setSelectedSimulation(index);
          }}
        >
          <Label style={{ padding: 4 }} variant={bsStyle}>
            {item.name}
          </Label>
        </a>
      );
    } else {
      if (additionalLayers.includes(item.layer)) {
        bsStyle = "primary";
      } else {
        bsStyle = "secondary";
      }
      label = (
        <a
          style={{ textDecoration: "none" }}
          onClick={() => {
            const additionalLayersCopy = [...additionalLayers];
            if (additionalLayersCopy.includes(item.layer)) {
              additionalLayersCopy.splice(additionalLayersCopy.indexOf(item.layer), 1);
            } else {
              additionalLayersCopy.push(item.layer);
            }
            setAdditionalLayers(additionalLayersCopy);
            // setSimulationStateInUrl(index, history);
            // setSelectedSimulation(index);
          }}
        >
          <Label style={{ padding: 4 }} variant={bsStyle}>
            {item.name}
          </Label>
        </a>
      );
    }

    simulationLabels.push(label);
  });

  let alwaysVisibleDiv = (
    <h4 style={{ margin: 0 }}>
      <Icon name={simObject.icon} /> {simObject.title} {"   "}
    </h4>
  );
  const debugLayout = false;

  let toggleComponent = null;

  if (animationSwitch === true) {
    toggleComponent = (
      <AdditionalToggleColumn
        toggleTitle="Animation"
        {...{
          toggleEnabled: animationEnabled,
          setToggleEnabled: setAnimationEnabled,
          toggleEnabledTooltip: "Fließgeschehen ausblenden",
          toggleDisabledTooltip: "Fließgeschehen darstellen",
          debugLayout,
          toggleClickable: true,
        }}
      />
    );
  } else if (toggleSwitch === true) {
    toggleComponent = (
      <AdditionalToggleColumn
        toggleTitle={toggleTitle}
        {...{
          toggleEnabled,
          setToggleEnabled,
          toggleEnabledTooltip,
          toggleDisabledTooltip,
          toggleEnabledText,
          toggleDisabledText,
          toggleClickable,
          debugLayout,
        }}
      />
    );
  } else {
    toggleComponent = null;
  }

  const components = {
    S: <SimulationColumn {...{ simulationTitle, simulationLabels, debugLayout }} />,
    M: <MapColumn {...{ backgrounds, selectedBackgroundIndex, setBackgroundIndex, debugLayout }} />,
    T: toggleComponent,
  };

  let filteredOrder = order;
  if (toggleComponent === null) {
    //remove "T" from the order array
    filteredOrder = order.filter((item) => item !== "T");
  }

  const collapsibleDiv = (
    <div>
      <p style={{ marginBottom: 5 }}>
        {simObject.subtitle}{" "}
        <a style={{ color: "#337ab7" }} onClick={() => showModalMenu("szenarien")}>
          (mehr)
        </a>
      </p>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          border: debugLayout ? "1px solid #ddd" : undefined,
        }}
      >
        {filteredOrder.map((item) => components[item])}
      </div>
    </div>
  );
  return (
    <ResponsiveInfoBox
      // style={{ cursor: mapCursor }}
      secondaryInfoBoxElements={secondaryInfoBoxElements}
      header={legendTable}
      fixedRow={false}
      pixelwidth={pixelwidth}
      alwaysVisibleDiv={alwaysVisibleDiv}
      collapsibleDiv={collapsibleDiv}
    />
  );
};

export default ControlInfoBox;
